<template>
    <Component :is="variationComponents[slice.variation as keyof typeof variationComponents]" v-bind="props" />
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {RichTextSlice} from '@prismicio-types';
    import RichTextDefault from './variations/RichTextDefault.vue';
    import RichTextWithShapes from './variations/RichTextWithShapes.vue';

    const props = defineProps(getSliceComponentProps<RichTextSlice>());

    const variationComponents = {
        default: RichTextDefault,
        richTextWithShapes: RichTextWithShapes,
    };
</script>
